const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
const SET_SEARCH = 'SET_SEARCH';
const SET_MAX_DOMAIN_AUTHORITY = 'SET_MAX_DOMAIN_AUTHORITY';

const state = {
  activeTab: 'pending',
  search: '',
  maxDomainAuthority: 5,
};

const getters = {
  activeTab: ({activeTab}) => activeTab,
  search: ({search}) => search,
  maxDomainAuthority: ({maxDomainAuthority}) => maxDomainAuthority,
};

const actions = {
  setActiveTab: ({commit}, tab) => commit(SET_ACTIVE_TAB, tab),
  setSearch: ({commit}, search) => commit(SET_SEARCH, search),
  setDomainAuthority: ({commit}, maxDomainAuthority) => commit(SET_MAX_DOMAIN_AUTHORITY, maxDomainAuthority),
};

const mutations = {
  [SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab;
  },
  [SET_SEARCH](state, search) {
    state.search = search;
  },
  [SET_MAX_DOMAIN_AUTHORITY](state, maxDomainAuthority) {
    state.maxDomainAuthority = maxDomainAuthority;
  },
};

const backlinkHealthcheck = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default backlinkHealthcheck;
